module.exports = __webpack_public_path__ + "img/mind_skeleton_time_12.a4969cb2.jpg";